import React from 'react';
import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import DateIntervalPicker from '../Forms/DateIntervalPicker';
import {makeTableData} from './utils';
import PlainButton from '../Buttons/PlainButton';
import MaxEnrolled from '../Inputs/MaxEnrolled';
import SimpleTable from './SimpleTable';
import useStyles from './styles';

const View = ({
  onRowClick,
  data,
  onChoose,
  maxEnrolled,
  onChangeMaxEnrolled,
  getToBeEnrolledDeliveries,
  isBusy,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  maxDate
}) => {

  const classes = useStyles();

  return <Grid container spacing={2}>
    <Grid item xs={12}>
      <QueueHeader
        {...{
          startDate,
          setStartDate,
          endDate,
          setEndDate,
          maxDate
        }}
      />
    </Grid>
    {!isEmpty(data) && !isBusy &&
    <Grid item xs={12}>
      <Grid container spacing={2} justify='flex-start' alignItems='center'>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2} alignItems='center' className={classes.maxEnrolled}>
            <Grid item xs={5}>
              <PlainButton color="primary" onClick={onChoose}>Delegar</PlainButton>
            </Grid>
            <Grid item xs={7}>
              <MaxEnrolled value={maxEnrolled} onChange={onChangeMaxEnrolled}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <PlainButton color="primary" onClick={getToBeEnrolledDeliveries}>Iniciar</PlainButton>
        </Grid>
      </Grid>
    </Grid>
    }
    <Grid item xs={12}>
      <QueueTable
        {...{isBusy, onRowClick, data}}
      />
    </Grid>
  </Grid>;
};

export const QueueTable = ({isBusy, data, onRowClick}) => {

  const classes = useStyles();

  const listData = makeTableData(data);

  const tableColumns = [
    { width: 120 , flexGrow: 1 , label: 'Veículo'        , dataKey: 'vehicleIdT'    , sortKey: 'vehicleId'    , numeric: false } ,
    { width: 150 , flexGrow: 1 , label: 'Acumulado (R$)' , dataKey: 'vehicleValueT' , sortKey: 'vehicleValue' , numeric: true }  ,
    { width: 130 , flexGrow: 1 , label: 'Pré Carga'      , dataKey: '_id'           , sortKey: '_id'          , numeric: true }  ,
    { width: 130 , flexGrow: 1 , label: 'Valor (R$)'     , dataKey: 'valueT'        , sortKey: 'value'        , numeric: true }  ,
    { width: 80  , flexGrow: 1 , label: 'Pesos'          , dataKey: 'slotNumber'    , sortKey: 'slotNumber'   , numeric: true }  ,
    { width: 80  , flexGrow: 1 , label: 'Final'          , dataKey: 'finalSlotT'    , sortKey: 'finalSlot'    , numeric: false } ,
    { width: 200 , flexGrow: 1 , label: 'Horário'        , dataKey: 'calendarT'     , sortKey: 'timestamp'    , numeric: true }  ,
    { width: 150 , flexGrow: 1 , label: 'Status'         , dataKey: 'statusT'       , sortKey: 'status'       , numeric: false } ,
  ];

  return isBusy
    ? <Grid container xs={12} justify='center'>
      <CircularProgress className={classes.spinner}/>
    </Grid>
    : !isEmpty(listData)
    ? <Grid item className={classes.queueContainer}>
      <SimpleTable
        sortBy={'total'}
        sortDirection={'DESC'}
        rowCount={listData.length}
        list={listData}
        rowHeight={78}
        onRowClick={onRowClick}
        columns={tableColumns}
      />
    </Grid>
    : <Grid container xs={12} justify='center'>
      <Typography variant='h6' className={classes.title}>
        Nenhum item encontrado...
      </Typography>
    </Grid>
};

export const QueueHeader = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  maxDate
}) => {

  const classes = useStyles();

  return <Grid
    container
    justify='center'
    alignItems='center'
    className={classes.header}
  >
    <Grid item xs={12}>
      <DateIntervalPicker disablePast disableFuture
      {...{startDate, setStartDate, endDate, setEndDate, maxDate}}/>
    </Grid>
  </Grid>;
};

export default View;
